export const apiURL = `${window.SW_DOMAIN}/api/v${window.SW_VERSION}/`;